module.exports = __webpack_public_path__ + "static/media/hero-home-video.31345579.mp4";